const DEFAULT_MULTI_SEARCH_LIMIT = 2;

export { DEFAULT_MULTI_SEARCH_LIMIT };
